import React, { useState, useEffect, useRef } from 'react';
import Pagination from "react-pagination-list";
import { fetcher } from '../fetchers';
import { isEqual, round } from 'lodash';

export const DEFAULT_DISCIPLINE_IDS = {
  open: 13,
  youth: 13,
  challenger: 13,
  pro: 13,
  all: 0,
};

const usePreviousValue = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const LeaderboardsResults = ({ segments, selectedType, selectedSegment, setLoading, typesList }) => {
  const [allLeaderboards, setAllLeaderboards] = useState([]);
  const [segmentLeaderboards, setSegmentLeaderboards] = useState([]);
  const [selectedLeaderboard, setSelectedLeaderboard] = useState();
  const prevTypeValue = usePreviousValue(selectedType);
  const prevSegmentValue = usePreviousValue(selectedSegment);

  const selectDefaultLeaderboard = (segLeaderboards)=> {
    const leaderboardId = DEFAULT_DISCIPLINE_IDS[selectedType];
    return segLeaderboards.filter((leaderboard, i) => {
      const hasDefaultDisciplineResults = segLeaderboards.some(dis => dis.id === leaderboardId) && leaderboard.id === leaderboardId;
      const useFirstLeaderboardDiscipline = !segLeaderboards.some(dis => dis.id === leaderboardId) && i === 0;
      return hasDefaultDisciplineResults || useFirstLeaderboardDiscipline;
    })[0];
  };

  const selectDiscipline = (segLeaderboards)=> {
    const selectedboard = selectDefaultLeaderboard(segLeaderboards);
    setSelectedLeaderboard(selectedboard);
    setLoading(false);
  };

  const changeSelectedDiscipline = (id)=> {
    const selectedboard = segmentLeaderboards.filter(leaderboard => leaderboard.id === parseInt(id))[0];
    setSelectedLeaderboard(selectedboard);
  };

  const getSegmentLeaderboards = async (allDisciplines) => {
    const isAllAround = selectedType === 'all';
    const segLeaderboards = isAllAround
      ? [{
          id: 0, 
          name: 'All Around', 
          sortOrder: 0, 
          leaderboard: []
        }]
      : [];

    const allAroundLeaderboard = segLeaderboards.find((elem) => elem.name === 'All Around');

    const mergeAllAroundResults = (leaderboards) => {
      const mergedLeaderboards = allAroundLeaderboard.leaderboard.reduce((acc, athlete, i) => {
        const { ERAUID, FullName, points, place, money, disciplineId,} = athlete;
        const found = acc.find(elem => elem.ERAUID == ERAUID);

        athlete.hasAllAround = false;
        athlete.disciplines = [];

        if (found) {
          const multipleDisciplines = found.disciplineId !== disciplineId;
          const hasAllAround = found.hasAllAround;
          const foundDisciplinePoints = found.disciplines.find(elem => elem.disciplineId == disciplineId);

          if (foundDisciplinePoints) {
            foundDisciplinePoints.points += points;
          } else {
            found.disciplines.push({disciplineId, points});
          }

          found.hasAllAround = hasAllAround || multipleDisciplines;
        } else {
          athlete.disciplines.push({disciplineId, points});
          acc.push({...athlete});
        }

        return acc;
      }, [])
        .reduce((acc, athlete) => {
          const athleteDisciplines = athlete.disciplines;
          athlete.points = 0;
          if (athleteDisciplines.length > 1) {
            athleteDisciplines.map((athleteDiscipline) => {
                athlete.points += athleteDiscipline.points
            });
          }
          if (athlete.points >= 15) acc.push(athlete);
          return acc;
        }, [])
        .sort((a, b) => {
          if (a.points < b.points) return 1;
          else if (a.points > b.points) return -1;
  
          if (a.pointsFirstPlace < b.pointsFirstPlace) return 1;
          else if (a.pointsFirstPlace > b.pointsFirstPlace) return -1;
  
          if (a.pointsSecondPlace < b.pointsSecondPlace) return 1;
          else if (a.pointsSecondPlace > b.pointsSecondPlace) return -1;
  
          if (a.pointsThirdPlace < b.pointsThirdPlace) return 1;
          else if (a.pointsThirdPlace > b.pointsThirdPlace) return -1;
  
          if (a.pointsFourthPlace < b.pointsFourthPlace) return 1;
          else if (a.pointsFourthPlace > b.pointsFourthPlace) return -1;
  
          if (a.pointsFifthPlace < b.pointsFifthPlace) return 1;
          else if (a.pointsFifthPlace > b.pointsFifthPlace) return -1;
  
          if (a.pointsSixthPlace < b.pointsSixthPlace) return 1;
          else if (a.pointsSixthPlace > b.pointsSixthPlace) return -1;
  
          if (a.pointsSixthPlace < b.pointsSixthPlace) return 1;
          else if (a.pointsSixthPlace > b.pointsSixthPlace) return -1;
  
          if (a.pointsSeventhPlace < b.pointsSeventhPlace) return 1;
          else if (a.pointsSeventhPlace > b.pointsSeventhPlace) return -1;
  
          if (a.pointsEightPlace < b.pointsEightPlace) return 1;
          else if (a.pointsEightPlace > b.pointsEightPlace) return -1;
  
          if (a.pointsNineththPlace < b.pointsNineththPlace) return 1;
          else if (a.pointsNineththPlace > b.pointsNineththPlace) return -1;
  
          if (a.pointsTenthPlace < b.pointsTenthPlace) return 1;
          else if (a.pointsTenthPlace > b.pointsTenthPlace) return -1;
  
          if (a.pointsD1 < b.pointsD1) return 1;
          else if (a.pointsD1 > b.pointsD1) return -1;
  
          if (a.pointsD2 < b.pointsD2) return 1;
          else if (a.pointsD2 > b.pointsD2) return -1;
  
          if (a.pointsD3 < b.pointsD3) return 1;
          else if (a.pointsD3 > b.pointsD3) return -1;
  
          if (a.pointsD4 < b.pointsD4) return 1;
          else if (a.pointsD4 > b.pointsD4) return -1;
  
          if (a.pointsD5 < b.pointsD5) return 1;
          else if (a.pointsD5 > b.pointsD5) return -1;
  
          if (a.pointsY1 < b.pointsY1) return 1;
          else if (a.pointsY1 > b.pointsY1) return -1;
  
          if (a.pointsY2 < b.pointsY2) return 1;
          else if (a.pointsY2 > b.pointsY2) return -1;
  
          if (a.pointsY3 < b.pointsY3) return 1;
          else if (a.pointsY3 > b.pointsY3) return -1;
  
          if (a.pointsY4 < b.pointsY4) return 1;
          else if (a.pointsY4 > b.pointsY4) return -1;
  
          if (a.pointsY5 < b.pointsY5) return 1;
          else if (a.pointsY5 > b.pointsY5) return -1;
        });

      return [{
        id: 0, 
        name: 'All Around', 
        sortOrder: 0, 
        leaderboard: mergedLeaderboards
      }];
    }

    const getDisciplineLeaderboards = (disciplineLeaderboards) => {
      disciplineLeaderboards.map((leaderboard, index) => {
        const hasLeaderboard = leaderboard.data.length;
        const discipline = allDisciplines[index];
        if (!!hasLeaderboard) { 
          if (isAllAround) {
            allAroundLeaderboard.leaderboard.push(...leaderboard.data);
          } else {
            segLeaderboards.push({ 
              id: discipline.id, 
              name: discipline.name, 
              sortOrder: discipline.SortOrder, 
              leaderboard: leaderboard.data 
            });
          }
        };
        if (allDisciplines.length === index + 1) {
          const sortedSegLeaderboards = isAllAround 
            ? mergeAllAroundResults(segLeaderboards) 
            : segLeaderboards.sort((a, b) => a.sortOrder - b.sortOrder);
          setSegmentLeaderboards(sortedSegLeaderboards);
          selectDiscipline(sortedSegLeaderboards);
        }
      })
    };
    const disciplineLeaderboards = await Promise.all(allDisciplines.map(async (discipline, index) => {
      const leaderboardAPIPath = selectedSegment.SegmentUID.length > 1 
        ? `/v1/contestants/leaderboard/public/?type=${ selectedType }&segment=${ selectedSegment.SegmentUID }&discipline=${ discipline.id }&startDate=${selectedSegment.StartDate}&endDate=${selectedSegment.EndDate}`
        : `/v1/contestants/leaderboard/public/?type=${ selectedType }&segment=${ selectedSegment.SegmentUID }&discipline=${ discipline.id }`
      return await fetcher( `get`, leaderboardAPIPath);
    }));

    getDisciplineLeaderboards(disciplineLeaderboards);
  };

  const getAllDisciplines = () => {
    setLoading(true);
    const handleSuccess = (res) => getSegmentLeaderboards(res.data);
    fetcher(`get`, `/v1/disciplines/public?nominatableOnly=true&segment=${ selectedSegment.SegmentUID }`)
      .then(handleSuccess, handleError)
      .catch(handleError);
  };

  const handleError = (error) => { throw error; };

  useEffect(() => {
    const propsChanged = 
      !!selectedType && 
      !!selectedSegment &&
      (!isEqual(prevTypeValue, selectedType) || !isEqual(prevSegmentValue, selectedSegment));
    if (propsChanged) getAllDisciplines();
  },[selectedType, selectedSegment]);

  //For simple reporting purposes
  function convertToCSV(arr) { 
    const filteredArr = arr
    // .slice(0,16)
    .reduce((acc, result) => {
      acc.push({fullname: result.FullName, points: result.points, position: result.position, });
      return acc;
    },[]
    )
    const array = [Object.keys(filteredArr[0])].concat(filteredArr)
  
    return array.map(it => {
      return Object.values(it).toString()
    }).join('\n')
  }

  return (
    <>
    <h4 className="leaderboard-breadcrumb">{
        selectedLeaderboard
          ? selectedSegment.isGroupedSegment 
            ? `${selectedType} / ${selectedSegment.Name} / ${selectedLeaderboard && selectedLeaderboard.name}`
            : `${selectedType} / Segment: ${selectedSegment.ShortName} / ${selectedLeaderboard && selectedLeaderboard.name}`
          : selectedSegment.ShortName.indexOf('DY') == 0
            ? <span className='lowerCaseHeader'>As of June 2022, the Division Youth Leaderboard can be viewed at DY.RODEO. Click <a className='headerLink' href="https://dy.rodeo/leaderboard/" title="https://dy.rodeo/leaderboard/" >HERE</a> to view.</span>
            : 'List is not available'
      }</h4>
      <div id="leaderboard-details">
      <div id="discipline-selection">
        {segmentLeaderboards && segmentLeaderboards.map((leaderboard) => (
          <button
            className="discipline-option"
            style={{color: (selectedLeaderboard && (leaderboard.id == selectedLeaderboard.id) ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0.3)')}}
            value={leaderboard.id}
            onClick={(e) => changeSelectedDiscipline(e.target.value)} >
            {leaderboard.name}
          </button>
        ))}
      </div>
      <div id="segment-leadboard">
        <div className="leaderboardRow">
          {segmentLeaderboards && segmentLeaderboards.map((leaderboards) => (
            <div
              className="columnContainer"
              key={leaderboards.id}
              style={{display: (selectedLeaderboard && leaderboards.id == selectedLeaderboard.id ? 'block' : 'none')}} >
              <div className="leaderboard-column">
                <ol id="discipline.class" className="rendered-list">
                  { leaderboards && leaderboards.leaderboard && (
                    <Pagination
                      id="leaderboard-list"
                      data={leaderboards.leaderboard}
                      pageSize={16}
                      renderItem={(athlete, key) => {
                        const rank = leaderboards.leaderboard.findIndex(li => li.ERAUID === athlete.ERAUID)+1;
                        const style = rank === athlete.QualifyingCutOff && leaderboards.name !== 'All Around' ? {borderBottom: "4px dashed #404040"} : {}
                        return (
                        <li key={key} className="athlete" style={style}>
                          <span className="rendered-list-rank">{rank}</span>
                          <span className="rendered-list-name">{athlete.FullName}</span>
                          <span className="rendered-list-number">{round(athlete.points, 3)}</span>
                        </li>
                      )
                      }}
                    />
                  )}
                </ol>
                { selectedLeaderboard?.leaderboard[0]?.QualifyingCutOff && leaderboards.name !== 'All Around' && (
                    <div>
                      <div style={{borderBottom: "4px dashed #404040", width: "50px", display: "inline-block", marginRight: "10px"}}>{` `}</div>
                      <span>Denotes qualified position cutoff for event</span>
                    </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
    
  );
};
